import authService from '@/core/auth/authentication-service'
import jwtDecode from 'jwt-decode'
import _ from 'lodash'

const state = {
  authenticationData: null
}

const actions = {
  tokenLogin({ commit }, payload) {
    commit('login', { accessToken: payload })
  },
  login({ commit }, payload) {
    return authService.login(payload).done(authenticationData => {
      commit('login', authenticationData)
    })
  },
  logout({ commit, dispatch }) {
    commit('logout')
    dispatch('resetEntityState')
  },
  checkAuth({ commit }) {
    if (state.authenticationData && !isExpiredToken(state.authenticationData)) {
      commit('login', state.authenticationData)
    }
  }
}

const mutations = {
  login(state, authenticationData) {
    state.authenticationData = authenticationData
  },
  logout(state) {
    state.authenticationData = null
  }
}

function isExpiredToken(authenticationData) {
  const decodedToken = jwtDecode(authenticationData.accessToken)
  return decodedToken.exp < Math.round(_.now() / 1000)
}

const getters = {
  isAuthenticated: state => state.authenticationData && !isExpiredToken(state.authenticationData),
  authenticationData: state => state.authenticationData
}

export default {
  state,
  actions,
  mutations,
  getters
}
